import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  fetchTours,
  fetchquotelist,
  fetchdestToursbyDest,
} from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
  checkboxalign: {
    alignSelf: "center",
    justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    //color: "red",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
  },
  button3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(4),
  },
  input: {
    color: "red",
  },
}));

export default function Turkey() {
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const [quotelist, setquotelist] = useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [listtourData, setlisttourData] = useState([
    {
      tour_name: "",
      tour_description: "",
      tour_city: "",
      tour_destination: "",
    },
  ]);

  useEffect(() => {
    loadtours();
    fetchQuotes();
  }, []);

  const loadtours = async () => {
    const data = await fetchdestToursbyDest("Turkey");
    //console.log(data);
    //const custdatalistfromdb= data.data
    setlisttourData(data.data);
  };
  const fetchQuotes = async () => {
    const data2 = await fetchquotelist("Turkey");
    setquotelist(data2.data);
  };

  //console.log(listtourData);
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab label="How to Describe" {...a11yProps(0)} />
            <Tab label="Itineraries and Cost" {...a11yProps(1)} />
            <Tab label="Sightseeing Descriptions" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Typography variant="h6" className={classes.input}>
            About Turkey:
          </Typography>
          <p>
          Turkey, straddling both Europe and Asia, is a vibrant destination rich in history, culture, and natural beauty. It is known for its diverse landscapes, Ottoman architecture, ancient ruins, bustling markets, and pristine beaches. Turkey offers something for every type of traveler — history buffs, adventure enthusiasts, shopaholics, and beach lovers.
          </p>
          <Typography variant="h6" className={classes.input}>
            Main Attractions:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Top Places:</b> Istanbul, Antalya, Cappadocia, Pamukkale, Kusadasi, Ankara
                Valley
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Istanbul:</b> Hagia Sophia, Blue Mosque, Topkapi Palace, Bosphorus cruise, Grand Bazaar
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Cappadocia:</b> Fairy chimneys, cave hotels, underground cities and its famous hot air balloon ride
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Antalya:</b> Amazing beaches, watersports, acquarium and waterfalls
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Pamukkale:</b> Thermal pools and white travertine terraces (UNESCO World Heritage Site)
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kusadasi/Izmir:</b> Ancient city of Ephesus, Zeus cave, Dilek Peninsula National Park, Ladies Beach & Pamucak Beach
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ankara:</b> Historical sites, castle, mosques
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Others:</b> Bodrumm, Fethiye, Konya, Troy & Gallipoli
              </ListItemText>
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.input}>
            Traveller type:
          </Typography>
          <p>Couples (P1), Family (P2), Friends (P3)</p>

          <Typography variant="h6" className={classes.input}>
            Duration:{" "}
          </Typography>
          <p>Min. 5 nights. Max. 14 nights</p>
          <Typography variant="h6" className={classes.input}>
            Visa Docuements required:{" "}
          </Typography>
          <p>Passport (with 6 months validity), confirmed return tickets, hotel bookings, financial proof, travel insurance, visa cost (around 21k)</p>
          <p>People with valid schengen, US or UK visa can apply for e-visa</p>
          <Typography variant="h6" className={classes.input}>
            How to reach:{" "}
          </Typography>
          <p>
          Direct flights to Istanbul from major Indian cities. Flight takes 6-7 hours. Connecting flights via Indian or Middle East cities will take 10-15 hours.
          Major airports:
            1.	Istanbul Airport (IST): Largest and busiest, ideal for international arrivals.
            2.	Sabiha Gökçen Airport (SAW): Serves Istanbul's Asian side.
            3.	Antalya Airport (AYT): Popular for tourists heading to coastal areas.

          </p>
          <Typography variant="h6" className={classes.input}>
            Distance between places:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Istanbul- Ankara:</b> 450 KM/ Approx 1 hr by flight || 6 hours by road || 5 hours by train 
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Istanbul- Cappadocia (Nevşehir):</b> 735 KM/ Approx 1.5 hrs by flight || 9 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Istanbul- Antalya:</b> 700 KM/ Approx 1.5 hrs by flight || 9 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Istanbul- Izmir:</b> 480 KM/ Approx 1 hr by flight || 6 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Istanbul- Kusadasi:</b> 570 KM/ Approx 1 hr by flight || 7 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Istanbul- Pamukkale:</b> 600 KM/ Approx 8 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Ankara- Cappadocia (Nevşehir):</b> 285 KM/ Approx  4 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Ankara- Antalya:</b> 500 KM/ Approx 1.5 hr by flight || 7 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Ankara- Izmir:</b> 580 KM/ Approx 1.5 hrs by flight || 8 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Ankara- Kusadasi:</b> 650 KM/ Approx 8 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Antalya- Cappadocia (Nevşehir):</b> 575 KM/ Approx  8 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Antalya- Pamukkale:</b> 240 KM/ Approx 3.5 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Antalya- Kusadasi/Izmir:</b> 411 KM/ Approx 5 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Cappadocia - Pamukkale:</b> 530 KM/ Approx 8 hours by road
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
              <b>Kusadasi- Izmir:</b> 100 KM/ Approx 1.5 hours by road
              </ListItemText>
            </ListItem>
          </List>
          <Typography variant="h6" className={classes.input}>
            Can be clubbed with:{" "}
          </Typography>
          <p>Greece</p>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography variant="h6" className={classes.input}>
            Flight cost: (per person return cost to Kochi)
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Mumbai:</b> 30-35k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Delhi:</b> 30-35k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Bengaluru:</b> 40-45k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Hyderabad:</b> 45-50k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Chennai:</b> 45-50k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ahmedabad:</b>40-45k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kolkata:</b> 40-45k
              </ListItemText>
            </ListItem>
          </List>
          <Typography variant="h6" className={classes.input}>
            Common Itineraries: (Cost and Quote Number)
          </Typography>
          <List>
            {quotelist?.map((quote) => {
              return (
                <div>
                  <ListItem disablePadding>
                    <ListItemText>
                      <b>
                        <a
                          href={
                            "/quotedataentry/" +
                            quote.quote_id
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {quote.quote_id} - {quote.quote_identifier}
                        </a>
                      </b>
                    </ListItemText>
                  </ListItem>
                </div>
              );
            })}
          </List>
          <Typography variant="h6" className={classes.input}>
            Total Cost: (per person without flights) 
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>5N:</b> 45-50k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>6N:</b> 60-65k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>8N:</b> 75-80k
              </ListItemText>
            </ListItem>
          </List>
        </TabPanel>
        <TabPanel value={value} index={2}>
          {listtourData.length > 1
            ? listtourData.map((tour) => (
                <div>
                <p className={classes.input}>{tour.tour_name} -- Start time:({tour.start_time}) || End time:({tour.end_time})</p>

                  {tour.tour_description}
                  <br></br>
                </div>
              ))
            : ""}
        </TabPanel>
      </Box>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
